<template>
  <div class="tab-content" id="PTtab-3" :key="'PTtab-3'" >
    <div>
      <div class="pagenamPT">
        <h3 class="pagename2 w100w">소속회원목록</h3>
      </div>
      <div class="sch_PC">
        <div class="PTsch flex-c">
          <div class="datesearchPTWarp flex-c gap-2">
            <h4>날짜</h4>
            <date-filter :retail="true" :defaultDay="0"
                         @search="getPartnerList(1)"
                         @update="onChangeDateTable"
                         :startDate="reqData.startDate"
                         :endDate="reqData.endDate" :id="'main-date-checkbox1'" @setOldYn="setOldYn" :oldYn="reqData.oldYn" :isOldYn="true"/>
          </div>
        </div>
      </div>
      <div class="sch_M">
        <div class="PTsch flex-c">
          <div class="datesearchM">
            <date-filter-mobile :retail="true" :id="'main-date-checkbox1'" :isOldYn="true"/>
          </div>
        </div>
      </div>
      <div class="sch_Normal">
        <div class="sch_Btm">
          <div class="searchPTwrap">
            <div class="searchPT w30p">
              <div class="datesearchPT flex-c gap-2">
                <h4>구분</h4>
                <select class="h36px">
                  <option value="memId" selected>아이디</option>
                  <option value="memNick">닉네임</option>
                  <option value="recommenderId">상위유저</option>
                </select>
              </div>
            </div>
            <div class="searchPT">
              <input type="text" :placeholder="$t('front.search.emptySearch')" v-model="searchMemId" class="h36px"/>
              <a @click="getPartnerList(1)" class="sch_Icon">
                <img src="@/assets/img/search.png" alt=""/>
              </a>
            </div>
          </div>
          <div class="searchPTwrap">
            <div class="datesearchPT flex-c gap-2 w30p">
              <h4>정렬</h4>
              <select v-model="orderStr" class="h36px">
                <option value=""></option>
                <option value="cashAmt_DESC">보유머니 많은순</option>
                <option value="cashAmt_ASC">보유머니 적은순</option>
                <option value="pointAmt_DESC">보유포인트 많은순</option>
                <option value="pointAmt_ASC">보유포인트 적은순</option>
                <option value="totalCashInAmt_DESC">입금금액 많은순</option>
                <option value="totalCashInAmt_ASC">입금금액 적은순</option>
                <option value="totalCashOutAmt_DESC">출금금액 많은순</option>
                <option value="totalCashOutAmt_ASC">출금금액 적은순</option>
                <option value="totalCashProfit_DESC">입출손익 많은순</option>
                <option value="totalCashProfit_ASC">입출손익 적은순</option>
                <option value="totalBetAmt_DESC">베팅금 많은순</option>
                <option value="totalBetAmt_ASC">베팅금 적은순</option>
                <option value="totalBetWinAmt_DESC">당첨금 많은순</option>
                <option value="totalBetWinAmt_ASC">당첨금 적은순</option>
                <option value="totalWlAmt_DESC">베팅손익 많은순</option>
                <option value="totalWlAmt_ASC">베팅손익 적은순</option>
                <option value="joinDate_DESC">가입일시 최신순</option>
                <option value="joinDate_ASC">가입일시 오래된순</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="PTsch flex-c">
        <div class="datesearchPTWarp flex-c gap-2">
          <h4>날짜</h4>
          <date-filter :retail="true" :defaultDay="0"
                       @search="getPartnerList(1)"
                       @update="onChangeDateTable"
                       :startDate="reqData.startDate"
                       :endDate="reqData.endDate" :id="'main-date-checkbox1'" @setOldYn="setOldYn" :oldYn="reqData.oldYn" :isOldYn="true"/>
        </div>
        <div class="datesearchM">
           <date-filter-mobile :retail="true" :id="'main-date-checkbox1'" :isOldYn="true"/>
        </div>
        <div class="searchPTwrap">
          <div class="searchPT">
            <div class="datesearchPT flex-c gap-2">
              <h4>구분</h4>
              <select class="h36px">
                <option value="memId" selected>아이디</option>
                <option value="memNick">닉네임</option>
                <option value="recommenderId">상위유저</option>
              </select>
            </div>
            <input type="text" :placeholder="$t('front.search.emptySearch')" v-model="searchMemId" class="h36px"/>
            <a @click="getPartnerList(1)" class="sch_Icon">
              <img src="@/assets/img/search.png" alt=""/>
            </a>
          </div>
          <div class="datesearchPT flex-c gap-2">
            <h4>정렬</h4>
            <select v-model="orderStr" class="h36px">
              <option value=""></option>
              <option value="cashAmt_DESC">보유머니 많은순</option>
              <option value="cashAmt_ASC">보유머니 적은순</option>

              <option value="pointAmt_DESC">보유포인트 많은순</option>
              <option value="pointAmt_ASC">보유포인트 적은순</option>

              <option value="totalCashInAmt_DESC">입금금액 많은순</option>
              <option value="totalCashInAmt_ASC">입금금액 적은순</option>

              <option value="totalCashOutAmt_DESC">출금금액 많은순</option>
              <option value="totalCashOutAmt_ASC">출금금액 적은순</option>

              <option value="totalCashProfit_DESC">입출손익 많은순</option>
              <option value="totalCashProfit_ASC">입출손익 적은순</option>

              <option value="totalBetAmt_DESC">베팅금 많은순</option>
              <option value="totalBetAmt_ASC">베팅금 적은순</option>

              <option value="totalBetWinAmt_DESC">당첨금 많은순</option>
              <option value="totalBetWinAmt_ASC">당첨금 적은순</option>

              <option value="totalWlAmt_DESC">베팅손익 많은순</option>
              <option value="totalWlAmt_ASC">베팅손익 적은순</option>

              <option value="joinDate_DESC">가입일시 오래된순</option>
              <option value="joinDate_ASC">가입일시 최신순</option>
            </select>
          </div>
        </div>
      </div> -->
      <div class="strTablescr">
         <div class="strTablePC">
            <table class="strTablePT">
              <colgroup>
                <col width="9%">
                <col width="9%">
                <col width="9%">
                <col width="9%">
                <col width="9%">
                <col width="9%">
                <col width="9%">
                <col width="9%">
                <col width="9%">
                <col width="9%">
                <col width="9%">
              </colgroup>
              <thead>
              <tr>
                <!-- <th>아이디</th>
                <th>닉네임</th>
                <th>상위 아이디</th>
                <th>카지노요율</th>
                <th>슬롯요율</th>
                <th>보유금</th>
                <th>보유포인트</th>
                <th>가입 일시</th>
                <th>머니 관리</th> -->
                <th>아이디</th>
                <th>닉네임</th>
                <th>롤링/루징<br>(카지노)</th>
                <th>보유머니</th>
                <th>보유포인트</th>
                <th>입/출금액</th>
                <th>입출손익</th>
                <th>베팅/당첨금액</th>
                <th>베팅손익</th>
                <th>머니관리</th>
                <th>가입일시</th>
              </tr>
              </thead>
              <tbody>
                <!-- <tr style="background: #f1f1f1;">
                  <td>(예시)booboo1</td>
                  <td class="nick">(예시)부엉이회원</td>
                  <td>
                    <div class="btn-input-wrap">
                      <span>0.00%/0.00%</span>
                      <a class="plus-btn" @click="onOpenRate()"></a>
                    </div>
                  </td>
                  <td>
                    <div class="btn-input-wrap">
                      <span>10,000,000</span>
                      <a class="inout-btn" @click="onOpenPay()">지급회수</a>
                    </div>
                  </td>
                  <td>
                    <div class="btn-input-wrap">
                      <span>100,000,000</span>
                      <a class="inout-btn" @click="onOpenPoint()">지급회수</a>
                    </div>
                  </td>
                  <td>
                    <div class="twoline-wrap">
                      <span><em>{{ $t('front.common.deposit') }}</em>100,000,000</span>
                      <span><em>{{ $t('front.common.withdrawal') }}</em>100,000,000</span>
                    </div>
                  </td>
                  <td>
                    -30,000,000
                  </td>
                  <td>
                    <div class="twoline-wrap">
                      <span><em>{{ $t('front.bettingStatus.BET') }}</em>100,000,000</span>
                      <span><em>{{ $t('front.common.winning') }}</em>100,000,000</span>
                    </div>
                  </td>
                  <td>
                    -30,000,000
                  </td>
                  <td>
                    <div class="btn-input-wrap">
                      <a class="inout-btn color-btn">베팅목록</a>
                    </div>
                  </td>
                  <td>2023-09-05 02:18:42</td>
                </tr> -->
                <tr v-for="(item, idx) in partnerList" :key="item.memId">
                  <td :class="item.myLevel">{{item.memId}}</td>
                  <td class="nick">{{item.memNick}}</td>
                  <!-- <td>{{item.recommenderId}}</td> -->
                  <td>
                    <div class="btn-input-wrap">
                      <span class="rate-font roboto">{{item.pointRate}}%/{{item.loseRate}}%</span>
                      <a class="plus-btn" @click="onOpenRate(item)"></a>
                    </div>
                  </td>
                  <!-- <td>{{item.casinoRate}}</td> -->
                  <!-- <td>{{item.slotRate}}</td> -->
                  <td>
                    <div class="btn-input-wrap">
                      <span class="mw-73">{{thousand(item.cashAmt)}}</span>
                      <a class="inout-btn" @click="onOpenPay(item, idx)">지급회수</a>
                    </div>
                  </td>
                  <td>
                    <div class="btn-input-wrap">
                      <span class="mw-73">{{thousand(item.pointAmt)}}</span>
<!--                      <a class="inout-btn" @click="onOpenPoint(item, idx)">지급회수</a>-->
                    </div>
                  </td>
                  <td>
                    <div class="twoline-wrap">
                      <span><em>{{ $t('front.common.deposit') }}</em>{{thousand(item.totalCashInAmt)}}</span>
                      <span><em>{{ $t('front.common.withdrawal') }}</em>{{thousand(item.totalCashOutAmt)}}</span>
                    </div>
                  </td>
                  <td>
                    {{thousand(item.totalCashProfit)}}
                  </td>
                  <td>
                    <div class="twoline-wrap">
                      <span><em>{{ $t('front.bettingStatus.BET') }}</em>{{thousand(item.totalBetAmt)}}</span>
                      <span><em>{{ $t('front.common.winning') }}</em>{{thousand(item.totalBetWinAmt)}}</span>
                    </div>
                  </td>
                  <td>
                    {{thousand(item.totalWlAmt)}}
                  </td>
                  <td>
                    <div class="btn-input-wrap">
                      <a class="inout-btn color-btn" @click="setMoneyMerge(item)">통합머니</a>
                    </div>
                  </td>
                  <td>{{dateFormatAll(item.joinDate)}}</td>
                  <!-- <td>{{dateFormatAll(item.joinDate)}}</td>
                  <td class="poin">
                    <a class="btnBlue btn2 btn3" @click="onOpenMoneyPopup(item)">지급/회수</a>
                    <a class="btnGrn2 btn3" @click="setMoneyMerge(item)">통합머니처리</a>
                    <div class="loginmodal" v-if="state !== 'ready'"></div>
                    <div v-if="item.openPopup" class="moneyg">
                      <h2>금액 입력</h2>
                      <a class="close" @click="onCloseMoneyPopup(item)"><img src="@/assets/img/icon_cancelB.svg" /></a>
                      <input type="text" pattern="[0-9.,]+" :placeholder="$t('front.give.moneyInput')" v-model="item.inputCashAmt" @keyup="updateCashAmt(item, $event.target.value)" />
                      <h3>보유머니: <em>{{thousand(item.cashAmt)}}</em></h3>
                      <div class="mbtn">
                        <a @click="setMoney(item, 10000)">1{{$t('front.cash.manwon')}}</a>
                        <a @click="setMoney(item, 30000)">3{{$t('front.cash.manwon')}}</a>
                        <a @click="setMoney(item, 50000)">5{{$t('front.cash.manwon')}}</a>
                        <a @click="setMoney(item, 100000)">10{{$t('front.cash.manwon')}}</a>
                      </div>
                      <div class="mbtn">
                        <a @click="setMoney(item, 300000)">30{{$t('front.cash.manwon')}}</a>
                        <a @click="setMoney(item, 500000)">50{{$t('front.cash.manwon')}}</a>
                        <a @click="setMoney(item, 1000000)">100{{$t('front.cash.manwon')}}</a>
                        <a @click="setMoney(item, 0)" style="background: #dadde2; color: #636971;">{{$t('front.cash.correct')}}</a>
                      </div>
                      <div class="submit">
                        <a class="bgb btn2" @click="memCash('-3', item)">{{$t('front.give.give')}}</a>
                        <a class="bgr btn2" @click="memCash('3', item)">{{$t('front.give.back')}}</a>
                      </div>
                    </div>
                  </td> -->
                </tr>
              </tbody>
            </table>
         </div>
         <!-- <div class="strTableM">
            <div class="strTablePTM">
              <ul v-for="(item) in partnerList" :key="item.memId">
                <li :class="item.myLevel">
                  <em>아이디</em>
                  <div><span>{{item.memId}}</span></div>
                </li>
                <li><em> </em> </li>
                <li>
                  <em>닉네임</em>
                  <div><span class="nick">{{item.memNick}}</span></div>
                </li>
                <li>
                  <em>롤링/루징<br>(카지노)</em>
                  <div class="m-table-r">
                    <span class="rate-font">{{item.pointRate}}%/{{item.loseRate}}%</span>
                    <a class="plus-btn" @click="onOpenRate(item)"></a>
                  </div>
                </li>
                <li>
                  <em>보유머니</em>
                  <div class="m-table">
                    <a class="inout-btn" @click="onOpenPay(item)">지급회수</a>
                    <span>{{thousand(item.cashAmt)}}</span>
                  </div>
                </li>
                <li>
                  <em>머니관리</em>
                  <div class="m-table">
                    <a class="inout-btn color-btn" @click="setMoneyMerge(item)">통합머니</a>
                  </div>
                </li>
                <li>
                  <em>보유포인트</em>
                  <div class="m-table">
                   <a class="inout-btn" @click="onOpenPoint(item)">지급회수</a>
                    <span>{{thousand(item.pointAmt)}}</span>
                  </div>
                </li>
                <li>
                  <em>가입 일시</em>
                  <div><span>{{dateFormatAll(item.joinDate)}}</span></div>
                </li>
                <li>
                  <em>입/출금액</em>
                  <div>column
                    <ul class="m-table-c">
                      <li>
                        <span>{{ $t('front.common.deposit') }}</span>
                        <span>{{thousand(item.totalCashInAmt)}}</span>
                      </li>
                      <li>
                        <span>{{ $t('front.common.withdrawal') }}</span>
                        <span>{{thousand(item.totalCashOutAmt)}}</span>
                      </li>
                    </ul>
                  </div>
                </li>
                <li>
                  <em>베팅/당첨금액</em>
                  <div>column
                    <ul class="m-table-c">
                      <li>
                        <span>{{ $t('front.bettingStatus.BET') }}</span>
                        <span>{{thousand(item.totalBetAmt)}}</span>
                      </li>
                      <li>
                        <span>{{ $t('front.common.winning') }}</span>
                        <span>{{thousand(item.totalBetWinAmt)}}</span>
                      </li>
                    </ul>
                  </div>
                </li>
                <li>
                  <em>입출손익</em>
                  <div>
                    <span>{{thousand(item.totalCashProfit)}}</span>
                  </div>
                </li>
                <li>
                  <em>베팅손익</em>
                  <div>
                    <span>{{thousand(item.totalWlAmt)}}</span>
                  </div>
                </li>
              </ul>
              <ul v-for="(item) in partnerList" :key="item.memId">
                <li :class="item.myLevel">
                  <em>아이디</em>
                  <div><span>{{item.memId}}</span></div>
                </li>
                 <li><em> </em> </li>
                 <li>
                  <em>닉네임</em>
                  <div><span>{{item.memNick}}</span></div>
                </li>
                <li>
                  <em>카지노요율</em>
                  <div><span>{{item.casinoRate}}</span></div>
                </li>
                <li>
                  <em>슬롯요율</em>
                  <div><span>{{item.slotRate}}</span></div>
                </li>
                <li>
                  <em>보유금</em>
                  <div><span>{{thousand(item.cashAmt)}}</span></div>
                </li>
                <li>
                  <em>보유포인트</em>
                  <div><span>{{thousand(item.pointAmt)}}</span></div>
                </li>
                <li>
                  <em>가입 일시</em>
                  <div><span>{{dateFormatAll(item.joinDate)}}</span></div>
                </li>
                <li>
                  <em>머니 관리</em>
                  <a class="bgr btn2 btn3" @click="onOpenMoneyPopup(item)">지급/회수</a>
                  <a class="bgg btn3" @click="setMoneyMerge(item)">통합머니처리</a>
                  <div v-if="item.openPopup" class="moneyg">
                    <a class="close" @click="onCloseMoneyPopup(item)"><img src="@/assets/img/icon_cancelB.svg" /></a>
                    <h2>보유머니: <span>{{thousand(item.cashAmt)}}</span></h2>
                    <input type="text" pattern="[0-9.,]+" :placeholder="$t('front.give.moneyInput')" v-model="item.inputCashAmt" @keyup="updateCashAmt(item, $event.target.value)" />
                    <div class="mbtn">
                      <a @click="setMoney(item, 10000)">1{{$t('front.cash.manwon')}}</a>
                      <a @click="setMoney(item, 30000)">3{{$t('front.cash.manwon')}}</a>
                      <a @click="setMoney(item, 50000)">5{{$t('front.cash.manwon')}}</a>
                      <a @click="setMoney(item, 100000)">10{{$t('front.cash.manwon')}}</a>
                    </div>
                    <div class="mbtn">
                      <a @click="setMoney(item, 300000)">30{{$t('front.cash.manwon')}}</a>
                      <a @click="setMoney(item, 500000)">50{{$t('front.cash.manwon')}}</a>
                      <a @click="setMoney(item, 1000000)">100{{$t('front.cash.manwon')}}</a>
                      <a @click="setMoney(item, 0)" style="background: #dadde2; color: #636971;">{{$t('front.cash.correct')}}</a>
                    </div>
                    <div class="submit">
                      <a class="bgb btn2" @click="memCash('-3', item)">{{$t('front.give.give')}}</a>
                      <a class="bgr btn2" @click="memCash('3', item)">{{$t('front.give.back')}}</a>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
         </div> -->
      </div>

      <pagination v-if="pageInfo"
                  :pageNum="pageInfo.page"
                  :pageSize="pageInfo.count_per_list"
                  :totalCount="pageInfo.tatal_list_count"
                  :className="'partnerPaging'"
                  @goToPage="getPartnerList"
      />
    </div>
    <div class="modal-wrapper">
      <div></div>
    </div>
    <transition name="fade">
      <TMmodal v-show="TMOpen" :isOpen="TMOpen" :type="'partner'" @close="onCloseTM" :userData="selectMem"/>
    </transition>
    <transition name="fade">
      <Paymodal v-if="PayMopen" :selectMem="selectMem" :selectIdx="selectIdx" @close="onClosePay"/>
    </transition>
    <transition name="fade">
      <PayPointmodal v-if="PayPMopen" :selectMem="selectMem" :selectIdx="selectIdx" @close="onClosePoint"/>
    </transition>
    <transition name="fade">
      <RateTable v-if="RateOpen" :selectMem="selectMem" @close="onCloseRate"/>
    </transition>
  </div>
</template>

<script>
import Pagination from '@/components/ui/Pagination.vue'
import {
  getRetailMyMemList, partnerLevels, partnerMyMemIds
} from '@/api/retail'
import { getDateStr, thousand } from '@/libs/utils'
import { memCashInOut } from '@/api/give'
import { mapState } from 'vuex'
import { PARTNER_LEVEL_NAME } from '@/libs/constants'
import DateFilter from '@/components/ui/DateFilter'
import DateFilterMobile from '@/components/ui/DateFilterMobile'
import TMmodal from '@/components/common/TotalMoney.vue'
import Paymodal from '@/components/common/Pay.vue'
import PayPointmodal from '@/components/common/PayPoint.vue'
import RateTable from '@/components/common/RateTable.vue'
import { addDays } from 'date-fns'

export default {
  name: 'PartnerList',
  components: { TMmodal, Pagination, Paymodal, PayPointmodal, DateFilter, DateFilterMobile, RateTable },
  computed: {
    ...mapState([
      'userData',
      'gameCount',
      'commonCodeByOrder',
      'commonCodeByCode'
    ]),
    partnerLevelName () {
      return PARTNER_LEVEL_NAME[this.item.partnerLevel]
    },
    formattedCashAmt () {
      if (!this.cashAmt) return ''
      return this.cashAmt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  },
  data () {
    return {
      searchType: 'N',
      searchPartnerLevel: '',
      partnerLevelList: [],
      partnerList: [],
      partnerLevelObject: null,
      summaryNew: null,
      searchMemId: '',
      cashAmt: '',
      selectIdx: '',
      selectMem: '',
      list: [],
      isProcessing: false,
      moveTarget: null,
      TMOpen: false,
      state: 'ready',
      PayMopen: false,
      PayPMopen: false,
      RateOpen: false,
      orderStr: '',
      reqData: {
        startDate: '',
        endDate: getDateStr(addDays(new Date(), 0), 'yyyy-MM-dd 23:59:59'),
        oldYn: false
      }
    }
  },
  async created () {
    this.emitter.emit('Loading', true)
    this.getPartnerLevels()
    this.getPartnerList(1)
    this.emitter.emit('Loading', false)
  },
  watch: {
    orderStr () {
      this.getPartnerList(1)
    },
    selectPartnerCode () {
      if (this.selectPartnerCode) {
        this.selectMem.cashAmt = ''
        this.getMyMemIds()
      }
    },
    selectMem () {
      if (this.selectMem) {
        this.selectMem.cashAmt = thousand(this.selectMem.cashAmt)
      }
    }
  },
  methods: {
    setOldYn (data) {
      this.reqData.oldYn = data
    },
    onChangeDateTable (value) {
      this.reqData.startDate = getDateStr(new Date(value.startDate))
      this.reqData.endDate = getDateStr(new Date(value.endDate))
    },
    thousand,
    onOpenMoneyPopup (value) {
      this.moveTarget = value
      console.log(value)
      value.openPopup = true
      this.state = 'open'
    },
    onCloseMoneyPopup (value) {
      this.moveTarget = null
      value.inputCashAmt = ''
      value.openPopup = false
      this.state = 'ready'
    },
    async setMoneyMerge (item) {
      this.selectMem = {
        ...item
      }
      const confirmMessage = `<span style="color: #5068d4;">${this.selectMem.memNick}</span>의 통합머니를 전환 처리하시겠습니까?<br><br><span style="font-size: 15px;color: #636971;">통합머니 처리 이후 환전이나 회수를 진행하지 않고 베팅을 하게되면 해당계정이 잠금 처리될 수 있습니다</span>`
      const confirmResult = await this.onConfirm(confirmMessage)
      if (confirmResult) {
        this.TMOpen = true
      }
    },
    onCloseTM () {
      this.selectMem = null
      this.TMOpen = false
    },
    onClosePay (newCash, idx) {
      if (newCash !== null) {
        this.partnerList[idx].cashAmt = newCash
      }
      this.PayMopen = false
      this.selectMem = null
    },
    onClosePoint (newPoint, idx) {
      if (newPoint !== null) {
        this.partnerList[idx].pointAmt = newPoint
      }
      this.PayPMopen = false
      this.selectMem = null
    },
    onOpenPay (selectMem, selectIdx) {
      this.selectIdx = selectIdx
      this.selectMem = {
        ...selectMem
      }
      this.PayMopen = true
    },
    onOpenPoint (selectMem, selectIdx) {
      this.selectIdx = selectIdx
      this.selectMem = {
        ...selectMem
      }
      this.PayPMopen = true
    },
    onOpenRate (selectMem) {
      this.selectMem = {
        ...selectMem
      }
      this.RateOpen = true
    },
    onCloseRate () {
      this.RateOpen = false
      this.selectMem = null
    },
    parseFormattedValue (value) {
      return value.replace(/,/g, '')
    },
    onChangePartnerLevel (partnerLevel) {
      this.searchPartnerLevel = partnerLevel
      this.getPartnerList(1)
    },
    getMyMemIds () {
      const params = {
        code: this.selectPartnerCode,
        masterCode: 'partner'
      }
      partnerMyMemIds(params).then(res => {
        const result = res.data
        if (result.resultCode === '0') {
          this.myMemIdsList = result.data.memIds
        }
      })
    },
    getPartnerList (page) {
      this.emitter.emit('Loading', true)
      if (!page) {
        page = this.pageInfo.page
      }

      const params = {
        searchMemId: this.searchMemId,
        page: page,
        partnerLevel: this.searchPartnerLevel,
        searchType: this.searchType,
        count_per_list: 40,
        ...this.reqData
      }

      if (this.orderStr) {
        const orderColumn = this.orderStr.split('_')[0]
        const orderType = this.orderStr.split('_')[1]

        params.orderColumn = orderColumn
        params.orderType = orderType
      }

      getRetailMyMemList(params).then(res => {
        this.emitter.emit('Loading', false)
        const result = res.data
        if (result.resultCode === '0') {
          this.partnerList = result.data.list

          this.partnerList.forEach(item => {
            item.inputCashAmt = ''
          })

          if (result.data.pageInfo) {
            this.pageInfo = result.data.pageInfo
          }
        }
      })
    },
    getPartnerLevels () {
      partnerLevels({}).then(res => {
        const result = res.data
        if (result.resultCode === '0') {
          this.partnerLevelList = result.data.list
          this.newPartnerLevel = result.data.list[0]

          const partnerObj = {}
          for (let i = 0; i < this.partnerLevelList.length; i++) {
            const item = this.partnerLevelList[i]
            const code = item.code
            const codeName = item.codeName

            if (!partnerObj[code]) {
              partnerObj[code] = codeName
            }
          }

          this.partnerLevelObject = partnerObj
        }
      })
    },
    async memCash (type, item) {
      const memId = item.memId
      const cashStr = item.inputCashAmt
      if (!cashStr) {
        await this.onAlert('warningart', 'front.give.moneyInput')
        return false
      }

      if (!memId) {
        await this.onAlert('warningart', '회원 아이디를 선택해주세요.')
        return false
      }

      if (!this.isProcessing) {
        const cash = Number(cashStr.replace(/,/g, ''))
        this.isProcessing = true

        const params = {
          memId: memId
        }
        if (type === '-3') {
          params.inAmt = cash
        } else {
          params.outAmt = cash
        }

        const message = this.$t('front.cash.moneyMoveConfirm', { memNick: memId, cashAmt: cashStr, type: type === '-3' ? '지급' : '회수' })

        const confirm = await this.onConfirm(message)
        if (confirm) {
          this.emitter.emit('Loading', true)
          memCashInOut(params, type).then(async response => {
            const result = response.data
            this.emitter.emit('Loading', false)
            if (result.resultCode === '0') {
              if (type === '-3') {
                await this.onCheck('지급 완료')
              } else {
                await this.onCheck('회수 완료')
              }
              item.inputCashAmt = ''
              this.getPartnerList(this.pageInfo.page)
            } else {
              await this.onAlert('warningart', result.resultMessage)
            }
            this.state = 'ready'
            this.isProcessing = false
          })
        } else {
          this.state = 'ready'
          this.isProcessing = false
        }
      }
    },
    updateCashAmt (item, value) {
      const parts = item.inputCashAmt.split('.')
      const v = parts[0].replace(/\D/g, '')
      const dec = parts[1]
      // const calcNum = Number((dec !== undefined ? v + '.' + dec : v))
      let n = new Intl.NumberFormat('en-EN').format(v)
      n = dec !== undefined ? n + '.' + dec : n
      if (v === '0' || v === '') {
        item.inputCashAmt = ''
      } else {
        item.inputCashAmt = n
      }
    },
    setMoney (item, value) {
      const currentMoney = Number(item.inputCashAmt.replace(/,/g, ''))
      if (value === 0) {
        item.inputCashAmt = (value).toString()
      } else {
        item.inputCashAmt = (currentMoney + value).toString()
      }
      this.updateCashAmt(item)
    }
  }
}
</script>
<style scoped src="@/styles/striNew.css"></style>
<style scoped>
  .submit {width: 100% !important; margin-top: 5px;}
  .submit a {
    width: 50% !important;
  }
  #PTtab-3 .strTablePT a.btn2{
    margin-left: 0;
  }
  .moneyg h2::after {
    content: '';
    position: absolute;
    width: 330px;
    height: 1px;
    background: #6d6d6d;
    bottom: -15px;
    left: 0;
  }
  @media (max-width: 1000px) {
  }
</style>
